export interface LabTest {
    testId?: string;
    test_id?: string;
    PK?: string;
    SK?: string;
    testName?: string;
    test_name?: string;
    testCode?: string;
    test_code?: string;
    category?: string;
    price?: string | number;
    cgstPct?: string | number;
    sgstPct?: string | number;
    igstPct?: string | number;
    totalGstPct?: string | number;
    gstAmount?: string | number;
    grandTotal?: string | number;
    isActive?: string | boolean;
    sampleType?: string;
    sample_type?: string;
    turnaroundHours?: string | number;
    turnaround_hours?: string | number;
    unit?: string;
    description?: string;
    createdAt?: string;
    created_at?: string;
    updatedAt?: string;
}

export interface LabTestParameter {
    paramName?: string;
    param_name?: string;
    unit?: string;
    referenceRange?: string;
    reference_range?: string;
    gender?: string;
    ageRange?: string;
    age_range?: string;
    criticalLow?: string;
    criticalHigh?: string;
}

export interface LabTestGroup {
    groupId?: string;
    group_id?: string;
    PK?: string;
    SK?: string;
    groupName?: string;
    group_name?: string;
    groupCode?: string;
    group_code?: string;
    description?: string;
    price?: string | number;
    isActive?: string | boolean;
    testIds?: string[];
    tests?: string[];
    createdAt?: string;
    updatedAt?: string;
}

export interface LabOrderTest {
    testId?: string;
    test_id?: string;
    SK?: string;
    PK?: string;
    testName?: string;
    test_name?: string;
    quantity?: string | number;
    price?: string | number;
    lineTotal?: string | number;
    line_total?: string | number;
    taxAmount?: string | number;
    tax_amount?: string | number;
    discountPct?: string | number;
    discount_pct?: string | number;
    reportStatus?: string;
    report_status?: string;
    createdAt?: string;
}

export interface LabOrder {
    orderId?: string;
    order_id?: string;
    SK?: string;
    PK?: string;
    invoiceNumber?: string;
    invoice_number?: string;
    patientId?: string;
    patientName?: string;
    patient_name?: string;
    patientFirstName?: string;
    patientLastName?: string;
    mrn?: string | null;
    mobile?: string;
    email?: string;
    age?: number | string;
    gender?: string;
    address?: string;
    referenceDoctor?: string;
    reference_doctor?: string;
    orderStatus?: string;
    order_status?: string;
    status?: string;
    slideLibraryStatus?: string;
    tests?: LabOrderTest[];
    netAmount?: string | number;
    subtotal?: string | number;
    discountAmount?: string | number;
    discount_amount?: string | number;
    taxAmount?: string | number;
    tax_amount?: string | number;
    cgstAmount?: string | number;
    sgstAmount?: string | number;
    igstAmount?: string | number;
    totalAmount?: string | number;
    total_amount?: string | number;
    paidAmount?: string | number;
    paid_amount?: string | number;
    balanceAmount?: string | number;
    balanceDue?: string | number;
    balance_due?: string | number;
    paymentMode?: string;
    payment_mode?: string;
    comments?: string;
    orderDate?: string;
    appointmentId?: string;
    appointmentType?: string;
    orderSource?: string;
    createdAt?: string;
    created_at?: string;
    updatedAt?: string;
    createdBy?: string;
    priority?: string;
    reportGeneratedAt?: string;
    reportKey?: string;
}

export interface LabSample {
    isRejected?: boolean | string;
    rejectionReason?: string;
    status?: string;
    accessionedBy?: string;
    accessionedAt?: string;
    inTransitAt?: string;
    collectedDate: any;
    sampleId?: string;
    sample_id?: string;
    SK?: string;
    PK?: string;
    orderId?: string;
    order_id?: string;
    testId?: string;
    test_id?: string;
    sampleTypeName?: string;
    sample_type_name?: string;
    bottleType?: string;
    bottle_type?: string;
    barcodeNumber?: string;
    barcode_number?: string;
    collectedMaxQty?: string;
    collected_max_qty?: string;
    collectedMinQty?: string;
    collected_min_qty?: string;
    isCollected?: boolean | string;
    is_collected?: boolean | string;
    collectedBy?: string;
    collected_by?: string;
    collectedAt?: string;
    comments?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface LabResultParameter {
    paramName?: string;
    param_name?: string;
    value?: string;
    unit?: string;
    referenceRange?: string;
    reference_range?: string;
    flag?: string;
    isAbnormal?: boolean;
    is_abnormal?: boolean;
    criticalLow?: string;
    criticalHigh?: string;
}

export interface LabResult {
    resultId?: string;
    result_id?: string;
    PK?: string;
    SK?: string;
    orderId?: string;
    order_id?: string;
    testId?: string;
    test_id?: string;
    testName?: string;
    test_name?: string;
    reportStatus?: string;
    status?: string;
    findings?: string;
    impression?: string;
    parameters?: LabResultParameter[];
    approvedBy?: string;
    rejectionReason?: string;
    rejection_reason?: string;
    submittedAt?: string;
    approvedAt?: string;
    createdAt?: string;
    updatedAt?: string;
    enteredBy?: string;
    verifiedBy?: string;
    verifiedAt?: string;
    criticalAcknowledgedBy?: string;
    criticalAcknowledgedAt?: string;
    criticalNote?: string;
}

export interface ReferenceDoctor {
    doctorId?: string;
    doctor_id?: string;
    PK?: string;
    SK?: string;
    doctorName?: string;
    doctor_name?: string;
    doctorName_lower?: string;
    specialization?: string;
    mobile?: string;
    email?: string;
    hospital?: string;
    commissionPct?: number | string;
    commission_pct?: number | string;
    isActive?: string | boolean;
    createdAt?: string;
    updatedAt?: string;
}

export interface LabSampleType {
    typeId?: string;
    sampleTypeId?: string;
    sample_type_id?: string;
    PK?: string;
    SK?: string;
    sampleTypeName?: string;
    sample_type_name?: string;
    description?: string;
    handlingInstructions?: string;
    handling_instructions?: string;
    bottleColor?: string;
    bottle_color?: string;
    department?: string;
    isActive?: string | boolean;
    createdAt?: string;
}

export interface LabConfig {
    configType?: string;
    configId?: string;
    labName?: string;
    lab_name?: string;
    address?: string;
    contact?: string;
    email?: string;
    logoUrl?: string;
    updatedAt?: string;
}

export interface LabDashboardStats {
    totalOrders?: number;
    total_orders?: number;
    pendingOrders?: number;
    pending_orders?: number;
    processingOrders?: number;
    processing_orders?: number;
    completedToday?: number;
    completed_today?: number;
    cancelledOrders?: number;
    cancelled_orders?: number;
    revenueToday?: number;
    revenue_today?: number;
    revenueThisMonth?: number;
    revenue_this_month?: number;
    totalRevenue?: number;
    total_revenue?: number;
    byStatus?: Record<string, number>;
    by_status?: Record<string, number>;
    dailyRevenue?: Array<{ date: string; amount: number }>;
    daily_revenue?: Array<{ date: string; amount: number }>;
    topTests?: Array<{ testName: string; count: number }>;
    top_tests?: Array<{ testName: string; count: number }>;
}

export const extractLabTestId = (test: LabTest): string =>
    String(test?.testId ?? test?.test_id ?? test?.SK ?? '');

export const extractLabTestGroupId = (group: LabTestGroup): string =>
    String(group?.groupId ?? group?.group_id ?? group?.SK ?? '');

export const extractLabOrderId = (order: LabOrder): string =>
    String(order?.orderId ?? order?.order_id ?? order?.SK ?? '');

export const extractLabInvoiceNumber = (order: LabOrder): string =>
    String(order?.invoiceNumber ?? order?.invoice_number ?? '');

export const extractLabSampleId = (sample: LabSample): string =>
    String(sample?.sampleId ?? sample?.sample_id ?? sample?.SK ?? '');

export const extractLabResultId = (result: LabResult): string =>
    String(result?.resultId ?? result?.result_id ?? result?.SK ?? '');

export const extractDoctorId = (doctor: ReferenceDoctor): string =>
    String(doctor?.doctorId ?? doctor?.doctor_id ?? doctor?.SK ?? '');

export const extractSampleTypeId = (st: LabSampleType): string =>
    String(st?.typeId ?? st?.sampleTypeId ?? st?.sample_type_id ?? st?.SK ?? '');

export const extractLabTestsList = (payload: unknown): LabTest[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload as LabTest[];
    const p = payload as any;
    return (p.tests ?? p.items ?? p.data ?? p.results ?? []) as LabTest[];
};

export const extractLabOrdersList = (payload: unknown): LabOrder[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload as LabOrder[];
    const p = payload as any;
    return (p.orders ?? p.items ?? p.data ?? p.results ?? []) as LabOrder[];
};

export const extractLabSamplesList = (payload: unknown): LabSample[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload as LabSample[];
    const p = payload as any;
    return (p.samples ?? p.items ?? p.data ?? p.results ?? []) as LabSample[];
};

export const extractLabResultsList = (payload: unknown): LabResult[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload as LabResult[];
    const p = payload as any;
    return (p.results ?? p.items ?? p.data ?? []) as LabResult[];
};

export const extractDoctorsList = (payload: unknown): ReferenceDoctor[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload as ReferenceDoctor[];
    const p = payload as any;
    return (p.doctors ?? p.items ?? p.data ?? p.results ?? []) as ReferenceDoctor[];
};

export const extractSampleTypesList = (payload: unknown): LabSampleType[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload as LabSampleType[];
    const p = payload as any;
    return (p.sampleTypes ?? p.sample_types ?? p.items ?? p.data ?? p.results ?? []) as LabSampleType[];
};

export const extractTestGroupsList = (payload: unknown): LabTestGroup[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload as LabTestGroup[];
    const p = payload as any;
    return (p.groups ?? p.testGroups ?? p.test_groups ?? p.items ?? p.data ?? p.results ?? []) as LabTestGroup[];
};

export const extractTestParametersList = (payload: unknown): LabTestParameter[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload as LabTestParameter[];
    const p = payload as any;
    return (p.parameters ?? p.items ?? p.data ?? []) as LabTestParameter[];
};

// ─── Field Normalizers ────────────────────────────────────────────────────────

export type OrderStatus = 'pending' | 'processing' | 'completed' | 'cancelled';

export const normalizeOrderStatus = (raw: any): OrderStatus => {
    const s = String(raw ?? '').toLowerCase().trim();
    if (s === 'processing' || s === 'in_progress' || s === 'in-progress') return 'processing';
    if (s === 'completed' || s === 'complete' || s === 'done' || s === 'success') return 'completed';
    if (s === 'cancelled' || s === 'canceled' || s === 'failed' || s === 'rejected') return 'cancelled';
    if (s === 'appointment_scheduled' || s === 'scheduled') return 'pending';
    return 'pending';
};

export type ResultStatus = 'draft' | 'pending_approval' | 'approved' | 'rejected';

export const normalizeResultStatus = (raw: any): ResultStatus => {
    const s = String(raw ?? '').toLowerCase().trim().replace(/ /g, '_');
    if (s === 'submitted' || s === 'under_review' || s === 'review' || s === 'pending_approval' || s === 'pending-approval') return 'pending_approval';
    if (s === 'approved' || s === 'signed' || s === 'finalized' || s === 'completed' || s === 'complete') return 'approved';
    if (s === 'rejected' || s === 'failed') return 'rejected';
    return 'draft';
};

export const extractOrderStatus = (order: LabOrder): OrderStatus =>
    normalizeOrderStatus(order?.orderStatus ?? order?.order_status ?? order?.status);

export type OrderPriority = 'stat' | 'urgent' | 'routine';

export const normalizeOrderPriority = (raw: any): OrderPriority => {
    const s = String(raw ?? '').toLowerCase().trim();
    if (s === 'stat') return 'stat';
    if (s === 'urgent') return 'urgent';
    return 'routine';
};

export const extractOrderPriority = (order: LabOrder): OrderPriority =>
    normalizeOrderPriority(order?.priority);


export const parseNumericRange = (range?: string): [number, number] | null => {
    if (!range) return null;
    const parts = range.split('-').map(s => Number(s.trim()));
    if (parts.length !== 2 || parts.some(n => isNaN(n))) return null;
    return [parts[0], parts[1]];
};

export const parseAmount = (v?: string | number | null): number => {
    if (v == null || v === '') return 0;
    const n = typeof v === 'number' ? v : parseFloat(String(v));
    return isNaN(n) ? 0 : n;
};

export const extractBalanceAmount = (order: LabOrder): number =>
    parseAmount(order?.balanceAmount ?? order?.balanceDue ?? order?.balance_due);

export const extractTotalAmount = (order: LabOrder): number =>
    parseAmount(order?.totalAmount ?? order?.total_amount);

export const extractPaidAmount = (order: LabOrder): number =>
    parseAmount(order?.paidAmount ?? order?.paid_amount);

export const extractNetAmount = (order: LabOrder): number =>
    parseAmount(order?.netAmount ?? order?.subtotal);

export const extractResultStatus = (result: LabResult): ResultStatus =>
    normalizeResultStatus(result?.reportStatus ?? result?.status);


export const formatCurrency = (amount?: string | number | null, symbol = '₹'): string => {
    const n = typeof amount === 'string' ? parseFloat(amount) : (amount ?? NaN);
    if (amount == null || isNaN(n)) return `${symbol}0.00`;
    return `${symbol}${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatLabDate = (raw?: string): string => {
    if (!raw) return '—';
    try {
        const d = new Date(raw);
        if (isNaN(d.getTime())) return raw;
        return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch {
        return raw;
    }
};

export const formatLabDateTime = (raw?: string): string => {
    if (!raw) return '—';
    try {
        const d = new Date(raw);
        if (isNaN(d.getTime())) return raw;
        return d.toLocaleString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit',
        });
    } catch {
        return raw;
    }
};

export const extractPatientName = (order: LabOrder): string =>
    String(order?.patientName ?? order?.patient_name ?? 'Unknown Patient');

export const extractTestName = (test: LabTest): string =>
    String(test?.testName ?? test?.test_name ?? 'Unnamed Test');

export const extractDoctorName = (doctor: ReferenceDoctor): string =>
    String(doctor?.doctorName ?? doctor?.doctor_name ?? 'Unknown Doctor');

export const isSampleCollected = (sample: LabSample): boolean => {
    const v = sample?.isCollected ?? sample?.is_collected;
    if (typeof v === 'boolean') return v;
    return String(v).toLowerCase() === 'true';
};

export const isSampleRejected = (sample: LabSample): boolean => {
    const v = sample?.isRejected;
    if (typeof v === 'boolean') return v;
    return String(v).toLowerCase() === 'true';
};

export type SampleStatus = 'pending' | 'collected' | 'in_transit' | 'accessioned' | 'rejected';

export const normalizeSampleStatus = (sample: LabSample): SampleStatus => {
    const raw = String(sample?.status ?? '').toLowerCase().trim();
    if (raw === 'collected' || raw === 'in_transit' || raw === 'accessioned' || raw === 'rejected' || raw === 'pending') {
        return raw as SampleStatus;
    }
    if (isSampleRejected(sample)) return 'rejected';
    if (isSampleCollected(sample)) return 'collected';
    return 'pending';
};

export const SAMPLE_STATUS_META: Record<SampleStatus, { label: string; bg: string; color: string }> = {
    pending: { label: 'Pending Collection', bg: 'rgba(107,114,128,0.1)', color: '#6B7280' },
    collected: { label: 'Collected', bg: 'rgba(217,119,6,0.1)', color: '#D97706' },
    in_transit: { label: 'In Transit', bg: 'rgba(59,130,246,0.1)', color: '#2563EB' },
    accessioned: { label: 'Accessioned', bg: 'rgba(5,150,105,0.1)', color: '#059669' },
    rejected: { label: 'Rejected', bg: 'rgba(220,38,38,0.1)', color: '#DC2626' },
};

export const SAMPLE_STATUS_FLOW: SampleStatus[] = ['pending', 'collected', 'in_transit', 'accessioned'];

export const extractNextToken = (payload: any): string | undefined => {
    return payload?.next_token ?? payload?.nextToken ?? payload?.LastEvaluatedKey ?? undefined;
};

export const ORDER_STATUS_META: Record<OrderStatus, { label: string; bg: string; color: string }> = {
    pending: { label: 'Scheduled', bg: 'rgba(217,119,6,0.1)', color: '#D97706' },
    processing: { label: 'Processing', bg: 'rgba(124,58,237,0.1)', color: '#7C3AED' },
    completed: { label: 'Completed', bg: 'rgba(16,185,129,0.1)', color: '#059669' },
    cancelled: { label: 'Cancelled', bg: 'rgba(239,68,68,0.1)', color: '#DC2626' },
};

// ─── Slide Library Status ─────────────────────────────────────────────────────
export type SlideLibraryStatus =
    | 'WAITING_FOR_LAB_REPORT'
    | 'SAMPLE_COLLECTED'
    | 'REPORT_READY'
    | 'SLIDE_UPLOADED'
    | 'IN_PROCESSING'
    | 'COMPLETED';

export const SLIDE_LIBRARY_STATUS_META: Record<string, { label: string; bg: string; color: string; dot: string }> = {
    WAITING_FOR_LAB_REPORT: { label: 'Awaiting Report', bg: 'rgba(107,114,128,0.10)', color: '#6B7280', dot: '#6B7280' },
    SAMPLE_COLLECTED: { label: 'Sample Collected', bg: 'rgba(217,119,6,0.10)', color: '#D97706', dot: '#D97706' },
    REPORT_READY: { label: 'Report Ready', bg: 'rgba(29,111,184,0.10)', color: '#1D6FB8', dot: '#1D6FB8' },
    SLIDE_UPLOADED: { label: 'Slide Uploaded', bg: 'rgba(124,58,237,0.10)', color: '#7C3AED', dot: '#7C3AED' },
    IN_PROCESSING: { label: 'In Processing', bg: 'rgba(124,58,237,0.10)', color: '#7C3AED', dot: '#7C3AED' },
    COMPLETED: { label: 'Completed', bg: 'rgba(16,185,129,0.10)', color: '#059669', dot: '#059669' },
};

export const extractSlideLibraryStatus = (order: LabOrder): string =>
    String(order?.slideLibraryStatus ?? '');

/**
 * Reconciles slideLibraryStatus with the order's actual report state.
 * slideLibraryStatus is stamped by the pathology/slide pipeline and can lag —
 * an order can be orderStatus="completed" with a reportKey/reportGeneratedAt
 * already on it while slideLibraryStatus is still "WAITING_FOR_LAB_REPORT".
 * Real-world orders (non-pathology, or pathology orders whose report already
 * exists) should read as report-ready rather than stuck "awaiting report".
 */
export const resolveLabStatus = (order: LabOrder): string => {
    const raw = extractSlideLibraryStatus(order);
    const reportReady = Boolean(order?.reportGeneratedAt || order?.reportKey) || extractOrderStatus(order) === 'completed';
    if (reportReady && (raw === '' || raw === 'PENDING' || raw === 'WAITING_FOR_LAB_REPORT')) return 'REPORT_READY';
    return raw;
};

/** Parses appointmentId like "APPT#2026-07-17T02:40:00+00:00" → Date */
export const extractAppointmentDate = (order: LabOrder): string => {
    const raw = order?.appointmentId ?? '';
    const iso = raw.replace(/^APPT#/, '');
    if (!iso) return '—';
    try {
        const d = new Date(iso);
        if (isNaN(d.getTime())) return '—';
        return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch { return '—'; }
};

export const RESULT_STATUS_META: Record<ResultStatus, { label: string; bg: string; color: string }> = {
    draft: { label: 'Draft', bg: 'rgba(107,114,128,0.1)', color: '#6B7280' },
    pending_approval: { label: 'Pending Approval', bg: 'rgba(59,130,246,0.1)', color: '#2563EB' },
    approved: { label: 'Approved', bg: 'rgba(16,185,129,0.1)', color: '#059669' },
    rejected: { label: 'Rejected', bg: 'rgba(239,68,68,0.1)', color: '#DC2626' },
};

export const PRIORITY_META: Record<OrderPriority, { label: string; bg: string; color: string }> = {
    stat: { label: 'STAT', bg: 'rgba(220,38,38,0.12)', color: '#DC2626' },
    urgent: { label: 'Urgent', bg: 'rgba(217,119,6,0.12)', color: '#D97706' },
    routine: { label: 'Routine', bg: 'rgba(107,114,128,0.1)', color: '#6B7280' },
};

export const PARAM_FLAG_META: Record<string, { label: string; bg: string; color: string }> = {
    N: { label: 'Normal', bg: 'rgba(16,185,129,0.08)', color: '#059669' },
    H: { label: 'High', bg: 'rgba(239,68,68,0.08)', color: '#DC2626' },
    L: { label: 'Low', bg: 'rgba(59,130,246,0.08)', color: '#2563EB' },
    C: { label: 'Critical', bg: 'rgba(220,38,38,0.16)', color: '#DC2626' },
};

const PALETTE = ['#045EB8', '#7C3AED', '#059669', '#D97706', '#DC2626', '#0891B2'];
export const pickLabColor = (id: string): string => {
    let n = 0;
    for (let i = 0; i < id.length; i++) n += id.charCodeAt(i);
    return PALETTE[n % PALETTE.length];
};

export const getInitials = (name: string): string => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
